<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import ImageElement from "../../components/pagesbuilder/elements/ImageElement";

    export default {
        name: "PreviewImageElement",
        mixins: [PreviewElement,ImageElement]
    }
</script>
